import { CreateAssetRequest } from "../models/asset.model";

export class GetAssetAdminAction {
  static readonly type = "[ADMIN] Get Assets";
}

export class GetSelectedAssetAdminAction {
  static readonly type = "[ADMIN] Get Selected Asset";
  constructor(public id: number) {}
}

export class AddAssetAdminAction {
  static readonly type = "[ADMIN] Add Asset";
  constructor(public assetData: CreateAssetRequest) {}
}

export class DeleteAssetAdminAction {
  static readonly type = "[ADMIN] Delete Asset";
  constructor(
      public id: number, 
      public assetType: string, 
      public resource: string
  ) {}
}

export class FilterAssetAdminAction {
  static readonly type = "[ADMIN] Filter Assets";
  constructor(
    public filter: { name?: string | null; type?: string | null }
  ) {}
}